var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _defs, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _defs2, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMidCultureResponsiveRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 843 279",
    style: {
      enableBackground: "new 0 0 843 279"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3DABE;}\n\t.st1{fill:#E5B279;}\n\t.st2{fill:#EDC79E;}\n\t.st3{fill:#D8E2E4;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st5{fill:#E8E8E7;}\n\t.st6{fill:none;stroke:#F3DABE;stroke-width:0.4577;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:#F1E8E6;}\n\t.st8{fill:none;stroke:#F3DABE;stroke-width:1.2212;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{clip-path:url(#SVGID_00000141440197508921940090000006312529590414587020_);}\n\t.st11{fill:#FA1439;}\n\t.st12{fill:#FCFCFC;}\n\t.st13{fill:#586753;}\n\t.st14{fill:#979AA2;}\n\t.st15{fill:#BFC8B8;}\n\t.st16{fill:#754C4E;}\n\t.st17{fill:#2F462F;}\n\t.st18{clip-path:url(#SVGID_00000022546809599330953180000012308985035413449617_);}\n\t.st19{fill:#A98E91;}\n\t.st20{fill:#2E3348;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,115h384l17.5-36h435v174H0V115z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M820,57c-38.7-18.8-96.5-13-128.4-8.9c-32.5,4.1-114.3,16.4-128.8,25.2c-4,2.4-7.9,5.8-7.9,5.8h227.4 c1.9,0,54.1,0,54.1,0C836.5,76.2,832.9,62.9,820,57z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M732.3,150.7c-42.5-31.5-123.7-33.4-169.8-32.6C443.4,120.4,388,155.1,366,175c-6,5.5-12,13-12,13h347 c3,0,68,0,68,0C769,181.6,745.4,160.4,732.3,150.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M469.8,185.4v-0.5c-0.9,0.9-2.1,1.3-3.4,1.3c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1 c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8 s-1.8-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1 c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.8-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8 s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.7-0.8c-0.8-0.5-1.4-1.2-1.9-2.1 c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8 s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1 c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.7-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8 s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1 c-0.4,0.5-0.8,1-1.2,1.5c-0.9,0.9-2.1,1.3-3.4,1.3c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1 s-1.7,0.8-2.6,0.8s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.8-0.3-2.6-0.8 c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1 c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.7,0.8 c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.8-0.3-2.6-0.8 c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.8-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1 c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8 s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.9-0.3-2.7-0.8c-0.8-0.5-1.4-1.2-1.9-2.1 c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.7,0.8-2.6,0.8c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1 c-0.8,0.5-1.7,0.8-2.6,0.8c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.3,0.5-0.6,1-0.9,1.5c-0.9,0.9-2.1,1.3-3.4,1.3 c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.7,0.8-2.6,0.8c-0.9,0-1.9-0.3-2.6-0.8 c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.7,0.8-2.6,0.8c-0.9,0-1.8-0.3-2.6-0.8s-1.4-1.2-1.9-2.1 c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.7,0.8-2.6,0.8c-0.9,0-1.8-0.3-2.6-0.8s-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1 c-0.8,0.5-1.7,0.8-2.7,0.8c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.7,0.8-2.7,0.8 c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.7,0.8-2.6,0.8c-0.9,0-1.8-0.3-2.6-0.8 s-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.7,0.8-2.6,0.8c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1 c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.7,0.8-2.6,0.8c-0.9,0-1.8-0.3-2.6-0.8s-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1 c-0.8,0.5-1.7,0.8-2.6,0.8c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.7,0.8-2.6,0.8 c-0.9,0-1.9-0.3-2.7-0.8s-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.7,0.8-2.6,0.8c-0.9,0-1.9-0.3-2.6-0.8 c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8s-1.8-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1 c-0.4,0.5-0.8,1-1.2,1.5c-0.9,0.9-2.1,1.3-3.4,1.3c-0.9,0-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1 s-1.7,0.8-2.6,0.8s-1.9-0.3-2.6-0.8c-0.8-0.5-1.4-1.2-1.9-2.1c-0.4,0.9-1.1,1.6-1.9,2.1s-1.7,0.8-2.6,0.8c-1.9,0-4.5-2.9-4.5-2.9 l-4.5,2.9h-3.1c-41.2,0-74.6,22.9-74.6,65.2h459.8V185.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.3,203.6c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.1,203.6c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129,203.6c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M134.8,203.6c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M140.7,203.6c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.5,203.6c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M152.3,203.6c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M158.1,203.6c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M164,203.6c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.8,217c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M198.6,217c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.4,217c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M210.3,217c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M216.2,217c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M222,217c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.8,217c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M233.6,217c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M239.5,217c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M233.8,197c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M239.6,197c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M245.4,197c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.3,197c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M257.2,197c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263,197c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268.8,197c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.6,197c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M280.5,197c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.8,195c0,1.3-1.3,2.3-2.9,2.3S87,196.2,87,195"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.6,195c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.4,195c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.3,195c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.2,195c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122,195c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M127.8,195c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.6,195c0,1.3-1.3,2.3-2.9,2.3c-1.6,0-2.9-1.1-2.9-2.3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139.4,195c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.8,219c0,1.3-1.3,2.3-2.9,2.3S74,220.2,74,219"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.6,219c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.4,219c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.3,219c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.2,219c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M109,219c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.8,219c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M120.6,219c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M126.4,219c0,1.3-1.3,2.3-2.9,2.3s-2.9-1.1-2.9-2.3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M836.5,111c-79.5,9.5-139.9,71.4-163.6,113.4c-6.5,11.6,1.3,27.6,12.8,27.6h150.9L836.5,111L836.5,111z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M760.3,203.9c-43-41.8-133.8-45.8-180.4-44.8c-120.4,3-176.4,49.1-198.6,75.5c-6.1,7.3,1.2,17.3,12,17.3H720 c3,0,64.6,0,64.6,0C784.5,230,760.3,203.9,760.3,203.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.8,238.6c-43-11.7-134.1-0.3-180.8,0c-109.5-13.6-140.7-7.4-163,0c-15.5,5.1-23.3,13.4-23.3,13.4h326.7 c3,0,5.8-0.2,8.1-0.7C460.9,247.6,519.7,245.9,472.8,238.6z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M825.1,226.2c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.4c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9 c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9 c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3 c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3 c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.4c-0.9,0.6-2,0.9-3,0.9s-2.1-0.3-3-0.9 c-0.9-0.6-1.6-1.4-2.1-2.4c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3 c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3 c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9 c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9 c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3 c-0.4,0.6-0.9,1.2-1.4,1.7c-0.7,0.6-1.4,1-2.3,1.3c-0.9,0.2-1.8,0.3-2.6,0.1c-0.9-0.2-1.7-0.5-2.4-1.1c-0.7-0.5-1.3-1.2-1.7-2 c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3 c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9 c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9 c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.4c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.4 c-0.5,1-1.2,1.8-2.1,2.4c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.4c-0.5,1-1.2,1.8-2.1,2.3 c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9s-2.1-0.3-3-0.9 c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3 c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3 c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9s-2.1-0.3-3-0.9 c-0.9-0.6-1.6-1.4-2.1-2.3c-0.3,0.6-0.6,1.2-1,1.7c-0.7,0.6-1.4,1-2.3,1.3c-0.9,0.2-1.8,0.3-2.6,0.1c-0.9-0.2-1.7-0.5-2.4-1.1 c-0.7-0.5-1.3-1.2-1.7-2c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3 c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9s-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3 c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9 c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.4c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9 c-0.9-0.6-1.6-1.4-2.1-2.4c-0.5,1-1.2,1.8-2.1,2.4c-0.9,0.6-2,0.9-3,0.9s-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.4 c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3 c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9 c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9 c-0.9-0.6-1.6-1.4-2.1-2.3c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3 c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.6-2,0.9-3,0.9s-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.4,0.6-0.9,1.2-1.4,1.7 c-0.7,0.6-1.4,1-2.3,1.3c-0.9,0.2-1.8,0.3-2.6,0.1c-0.9-0.2-1.7-0.5-2.4-1.1s-1.3-1.2-1.7-2c-0.5,1-1.2,1.8-2.1,2.3 c-0.9,0.6-2,0.9-3,0.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.6-1.4-2.1-2.3c-0.1,0.3-0.3,0.5-0.4,0.7V253h421v-28.3 C827.9,225.7,826.6,226.2,825.1,226.2z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.8,217c-68.2-8.6-130.4-3.9-214.8,20.5c-17.1,5-24.4,11.6-29.1,15.5h359C472,237.5,472.5,228,384.8,217z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.9,245.8l2.2-2.7l-2.2,0.4V245.8z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M290.2,218.8l5.2,24l18.9-2.2v-2.2l2.1-0.4l-4.6-22L290.2,218.8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.5,221.6l0.4,1.8l2.7-0.4l0.2,0.9l1.3-2.1l-2.2-1.5l0.3,0.9L293.5,221.6z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.4,221.7c0,0,6.8-1.6,8.9,0.5c2.1,1.9,0.4,6.7-4.5,6.7s-3.7-4.2-1.3-4.1s6.7,3,4.4,5.2 c-2.3,2.2-5.2,0.1-8.8,2.6c-2.2,1.6-1.7,8,4.4,4.8c2.5-1.3,4.7-2.7,7.5-2.3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.6,237.4l-1.3-0.9l1-1.4l-0.6-0.5l-1,1.4l-1.3-1l-0.5,0.7l1.3,0.9l-0.9,1.2l0.6,0.5l0.9-1.2l1.3,0.9 L313.6,237.4z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M255,229.2c7.8,0,14-6.2,14-14s-6.2-14-14-14c-7.8,0-14,6.2-14,14C241,222.9,247.2,229.2,255,229.2z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,215.2l2.2,2.2l-2.2,7.7L255,215.2L255,215.2z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,215.2l-2.2-2.2l2.2-7.6V215.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,215.2l-2.2,2.2l-7.6-2.2H255z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,215.2l2.2-2.2l7.7,2.2H255z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,215.2l-2.2,2.2l2.2,7.7V215.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,215.2l2.2-2.2l-2.2-7.6L255,215.2L255,215.2z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,215.2l2.2,2.2l7.7-2.2H255z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,215.2l-2.2-2.2l-7.6,2.2H255z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.9,204.1l-7.2,10.4l-4.7,12.1l7.3-10.8L260.9,204.1z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,216.1c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9C254.1,215.7,254.5,216.1,255,216.1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M255,228.5c7.4,0,13.3-5.9,13.3-13.3c0-7.4-5.9-13.3-13.3-13.3c-7.4,0-13.3,5.9-13.3,13.3 C241.7,222.6,247.6,228.5,255,228.5z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.4,208.4l-29.3-5.9l7.3-1.5l29.3,5.9L372.4,208.4z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.7,195.7c1.2,0,2-0.9,2-2c0-1.2-0.9-2-2-2c-1.2,0-2,0.9-2,2C371.7,194.9,372.5,195.7,373.7,195.7z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368,202.7v6.8c0,0.5,0.3,0.8,0.8,0.8h6.2c0.5,0,0.8-0.3,0.8-0.8v-6.8H368L368,202.7z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.1,202.1h-8.6v1.5h8.6V202.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M371.8,192.1v10.6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.7,191.8c1.2,0,2-0.9,2-2c0-1.2-0.9-2-2-2c-1.2,0-2,0.9-2,2C371.7,190.9,372.5,191.8,373.7,191.8z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369.7,195.7c1.2,0,2-0.9,2-2c0-1.2-0.9-2-2-2c-1.2,0-2,0.9-2,2C367.7,194.9,368.6,195.7,369.7,195.7z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369.7,191.8c1.2,0,2-0.9,2-2c0-1.2-0.9-2-2-2c-1.2,0-2,0.9-2,2C367.7,190.9,368.6,191.8,369.7,191.8z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M371.8,193.7c1.2,0,2-0.9,2-2c0-1.2-0.9-2-2-2c-1.2,0-2,0.9-2,2C369.7,192.8,370.7,193.7,371.8,193.7z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M369.5,203.6h-1v5.4h1V203.6z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M369.4,203.4v-1H368v1H369.4z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M371.7,203.6h3.6v3.8L371.7,203.6z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.6,193.9l14.9,15l1-1l-14.9-15L349.6,193.9z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M349.8,199.9l7.2-7.2l-1-1l-0.3,0.1c-0.6,0.6-1.5,0.6-2,0l-0.2-0.2l-5.9,5.9 C347.5,197.7,349.9,199.9,349.8,199.9z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.2,217.6l-27.4-6.4l7.3-1.5l29.3,5.9L363.2,217.6z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M372.4,215.9l-29.3-6.1v-7.5l29.3,5.9V215.9z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M360.7,225.4l-29.4-5.9v-7.6l29.4,5.9V225.4z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375.3,214.9l-14.6,2.9v7.6l14.6-3V214.9z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.4,215.9l7.3-1.5v-7.6l-7.3,1.5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.8,210.4l-7.3,1.5v7.6l7.3-1.6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.4,211.9l-29.3-6.1l7.3-1.5l29.3,6.1L356.4,211.9z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332,208.6c0.5,0,0.9-0.9,0.8-1.8c-0.1-1-0.6-1.7-1.1-1.7s-0.9,0.9-0.8,1.8C331,207.8,331.5,208.6,332,208.6z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.4,207v-0.6l-0.1-1.2l10.9-0.9l0.3,3.5l-11.1,0.9L331.4,207L331.4,207z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339,206.3l-0.1-1l-0.2-2.3l5.9-0.6l0.6,7l-5.9,0.6L339,206.3z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.3,209.9c0.8-0.1,1.3-1.7,1.1-3.6c-0.2-1.9-0.9-3.4-1.7-3.4c-0.8,0.1-1.3,1.7-1.1,3.6 C337.7,208.5,338.5,210,339.3,209.9z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.6,210.9l-0.9-10.4l-3.5,0.3c-1.1,0.1-1.8,2.5-1.6,5.3c0.2,2.8,1.4,5.1,2.4,5c0.1,0,0.2-0.1,0.3-0.1 L348.6,210.9z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.6,210.9c1.1-0.1,1.8-2.4,1.6-5.3c-0.2-2.8-1.4-5.1-2.4-5s-1.8,2.4-1.6,5.3S347.6,211,348.6,210.9z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M348.5,209.6c0.9-0.1,1.5-1.8,1.3-4.1c-0.2-2.1-1.1-3.9-1.8-3.8c-0.9,0.1-1.5,1.8-1.3,4.1 C346.8,208,347.7,209.7,348.5,209.6z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.9,205.4c0.2-0.1,0.3-0.6,0.2-1.2c-0.2-0.6-0.5-1.1-0.7-1s-0.3,0.6-0.2,1.2 C348.4,205,348.7,205.4,348.9,205.4z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M339,205.2c0.3-0.2,0.8-0.5,1.2-0.7c-0.2-0.6-0.6-0.9-0.9-0.9c-0.5,0-0.8,0.8-0.9,1.8 C338.5,205.4,338.7,205.3,339,205.2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M342.1,203.3l-2.9,0.2l0.1,1.4C340.4,204.5,341.2,203.9,342.1,203.3z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M360.5,200.3l-11.2,11.2l1.9,1.9l11.2-11.2L360.5,200.3z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.7,197l-5.2,3.3l2,2L365.7,197z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.4,198.6c0.1,0.1,0.1,0.1,0.2,0.1h0.1l1.2-1.8l-1.8,1.2C364,198.3,364.1,198.5,364.4,198.6z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M356.4,219.4l-29.3-6.1v-7.5l29.3,5.9V219.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 552,
    y: 92,
    width: 33,
    height: 69
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140715278221694122060000011180314935308508555_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140715278221694122060000011180314935308508555_)"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M563.6,154.9v2.9l-4.1,3.2h4.6l1-1.4l0.4,1.4h1.2v-6.1L563.6,154.9L563.6,154.9z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M572.5,154.9v2.9l4.1,3.2H572l-1-1.4l-0.4,1.4h-1.2v-6.1L572.5,154.9L572.5,154.9z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M556.9,131.1l-3-2.9c-0.6-0.6-1.1-1.4-1.5-2.2c-0.3-0.8-0.5-1.7-0.4-2.6s0.3-1.7,0.8-2.5 c0.4-0.8,1-1.5,1.8-2l3.1-2.3l2.6,3.5l-3.1,2.3c-0.2,0.2-0.4,0.4-0.5,0.6s-0.2,0.5-0.2,0.7c0,0.3,0,0.5,0.1,0.8 c0.1,0.2,0.2,0.5,0.4,0.6l3,2.9L556.9,131.1z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M556.9,116.4l2.5,8.9l14.5-0.7l1.7-8.2C575.6,116.4,556.9,116.4,556.9,116.4z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M552.9,155.7H585v-17.9c0-7-6.9-13.1-12.1-13.1h-10.5c-2.5,0-4.9,1-6.7,2.7c-1.8,1.7-2.8,4.1-2.8,6.6V155.7z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M559.4,125.3l14.5-0.7l0.1-0.7h-15.1L559.4,125.3z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M574.2,131.3l-2.6-3.5l3.1-2.3c0.2-0.2,0.4-0.4,0.5-0.6s0.2-0.5,0.2-0.7c0-0.3,0-0.5-0.1-0.8 c-0.1-0.2-0.2-0.5-0.4-0.6l-3-2.9l3.1-3.1l3,2.9c0.6,0.6,1.1,1.4,1.5,2.2c0.3,0.8,0.5,1.7,0.4,2.6s-0.3,1.7-0.8,2.5 c-0.4,0.8-1,1.5-1.8,2L574.2,131.3z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M575,129.9c0.2-1.1-0.6-2.2-1.8-2.4c-1.2-0.2-2.3,0.6-2.5,1.7s0.6,2.2,1.8,2.4 C573.7,131.8,574.8,131,575,129.9z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M561.2,116.4l2.9,4.8l3.2-0.4l3.3-4.4H561.2z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.3,103.4h-7.1c-0.3,0-0.6,0.3-0.6,0.6v2c0,0.3,0.3,0.6,0.6,0.6h7.1c0.3,0,0.6-0.3,0.6-0.6v-2 C562.9,103.7,562.6,103.4,562.3,103.4z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.3,105.9h-7.1c-0.3,0-0.6,0.3-0.6,0.6v2c0,0.3,0.3,0.6,0.6,0.6h7.1c0.3,0,0.6-0.3,0.6-0.6v-2 C562.9,106.1,562.6,105.9,562.3,105.9z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.3,108.1h-7.1c-0.3,0-0.6,0.3-0.6,0.6v2c0,0.3,0.3,0.6,0.6,0.6h7.1c0.3,0,0.6-0.3,0.6-0.6v-2 C562.9,108.3,562.6,108.1,562.3,108.1z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.3,110.5h-7.1c-0.3,0-0.6,0.3-0.6,0.6v2c0,0.3,0.3,0.6,0.6,0.6h7.1c0.3,0,0.6-0.3,0.6-0.6v-2 C562.9,110.8,562.6,110.5,562.3,110.5z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M565.8,109.4c4.9,0,8.9-3.9,8.9-8.7c0-4.8-4-8.7-8.9-8.7s-8.9,3.9-8.9,8.7 C556.9,105.5,560.9,109.4,565.8,109.4z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M564.1,116.4l1,1.5c0.8,0.1,1.6,0.1,2.4,0.2l0.5-1.6v-4.1l3.6-2.7l-0.6-5.6l-7.4-3.9l-4.8,4.5l1.6,6.4 l3.1,1.2L564.1,116.4z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.6,103.4h-7.1c-0.3,0-0.6,0.3-0.6,0.6v2c0,0.3,0.3,0.6,0.6,0.6h7.1c0.3,0,0.6-0.3,0.6-0.6v-2 C577.1,103.7,576.9,103.4,576.6,103.4z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.6,105.9h-7.1c-0.3,0-0.6,0.3-0.6,0.6v2c0,0.3,0.3,0.6,0.6,0.6h7.1c0.3,0,0.6-0.3,0.6-0.6v-2 C577.1,106.1,576.9,105.9,576.6,105.9z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.6,108.1h-7.1c-0.3,0-0.6,0.3-0.6,0.6v2c0,0.3,0.3,0.6,0.6,0.6h7.1c0.3,0,0.6-0.3,0.6-0.6v-2 C577.1,108.3,576.9,108.1,576.6,108.1z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.6,110.5h-7.1c-0.3,0-0.6,0.3-0.6,0.6v2c0,0.3,0.3,0.6,0.6,0.6h7.1c0.3,0,0.6-0.3,0.6-0.6v-2 C577.1,110.8,576.9,110.5,576.6,110.5z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M562.4,105.9c0.4,0,0.8-0.3,0.8-0.8c0-0.4-0.4-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8 C561.6,105.6,561.9,105.9,562.4,105.9z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M564.6,105.9c0.4,0,0.8-0.3,0.8-0.8c0-0.4-0.4-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8S564.2,105.9,564.6,105.9 z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M561.7,107.3h5.6l-2.7,2.1L561.7,107.3z"
  }))))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M504.5,131.1l14.6-4.6l2.9-11.9l-3.6-0.9l-2.4,9.8l-12.6,3.9L504.5,131.1z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M519.5,115.4c-1.4-0.7-1.9-2.4-1.2-3.7c0.7-1.4,2.4-1.9,3.7-1.2c1.4,0.7,1.9,2.4,1.2,3.7 S520.9,116.1,519.5,115.4z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M532,111.3l13.7,3.9l-6.3-16L532,111.3z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M540.5,108.1c-1.7-4.4-2-8.5-0.5-9.1s4.1,2.5,5.8,7c1.7,4.4,2,8.5,0.5,9.1 C544.8,115.6,542.2,112.5,540.5,108.1z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M515.7,114.9l6.4-2.5c0.5,0.9,1.4,1.5,2.3,1.8c1,0.3,2,0.3,3-0.1l11.8-4.6l-0.7-1.8l-11.8,4.6 c-0.5,0.2-1,0.2-1.5,0.1s-1-0.4-1.3-0.8l3.3-1.3c1.1-0.4,1.9-1.3,2.4-2.3c0.5-1.1,0.5-2.3,0.1-3.3c-0.4-1.1-1.3-1.9-2.3-2.4 c-1.1-0.5-2.3-0.5-3.3-0.1l-1.1,0.4c-1.1,0.4-1.9,1.3-2.4,2.3c-0.5,1.1-0.5,2.3-0.1,3.4l0.9,2.3l-6.3,2.5L515.7,114.9z M525.6,103.8 c0.6,0,1.1,0.2,1.6,0.6c0.4,0.4,0.7,0.9,0.9,1.4c0.1,0.6,0,1.2-0.3,1.7s-0.7,0.9-1.3,1.1l-3.4,1.3l-0.9-2.3c-0.2-0.6-0.2-1.3,0-1.9 c0.3-0.6,0.8-1.1,1.4-1.3l1.1-0.4C525,103.9,525.3,103.8,525.6,103.8L525.6,103.8z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M508.6,178.8l5.7,3.8h-10.5c0,0-0.8-3.8,0-3.8H508.6z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M490.3,178.8h4.6l2.6,4.2h-7.3L490.3,178.8L490.3,178.8z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M486.6,148.3l3.5-1.4l-3.8-9.4l7.9-10.6l-3-2.2L482,137L486.6,148.3z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M486,149.5c-0.2-1.5,0.8-2.9,2.3-3.2c1.5-0.2,2.9,0.8,3.2,2.3c0.2,1.5-0.8,2.9-2.3,3.1 C487.6,152,486.2,151,486,149.5z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M501,121.6l-9.9,1.3l-0.4,18.9l2.4,7.9h14.3l1.4-8.3l-4-6.3l-0.2-9.5L501,121.6z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M493.4,162.8l-0.3-13.1l0,0l-2.4-7.9l0.2-9.7l3.2,1.3l3.9-2.5l-2.4-8.8l2.6-0.1l2.4,8.4l4.1,0.1l4,10.8 l-1.3,8.1l1.2,29.3h-4.8l-3-23.1l-1.8,11l-4.2,12.1h-4.6L493.4,162.8z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M506,132.6l-3.8,0.1l1.2,3.8l3.1-0.8L506,132.6z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M515.9,109.7v8.3l-6.2,4.4l-8.5,4.2l-1.7-3.5l3.6-3.7V106l8.2-3.3L515.9,109.7z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M512.4,113.8c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S513.6,113.8,512.4,113.8z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M516.8,113.1c-1.2,0-2.1-1-2.1-2.1c0-1.2,1-2.1,2.1-2.1s2.1,1,2.1,2.1C519,112.1,518,113.1,516.8,113.1z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M512.4,113.8c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S513.6,113.8,512.4,113.8z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M516.8,113.1c-1.2,0-2.1-1-2.1-2.1c0-1.2,1-2.1,2.1-2.1s2.1,1,2.1,2.1C519,112.1,518,113.1,516.8,113.1z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.4,114.3c0.5,0,1-0.1,1.4-0.4s0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.4c-0.1-0.5-0.3-0.9-0.7-1.3 c-0.3-0.3-0.8-0.6-1.3-0.7s-1,0-1.4,0.1c-0.5,0.2-0.8,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.7,0.3,1.3,0.7,1.8 C511.1,114,511.8,114.2,512.4,114.3z M512.4,110.1c0.3,0,0.6,0.1,0.9,0.3c0.3,0.2,0.5,0.4,0.6,0.7c0.1,0.3,0.2,0.6,0.1,0.9 c-0.1,0.3-0.2,0.6-0.4,0.8c-0.2,0.2-0.5,0.4-0.8,0.4c-0.3,0.1-0.6,0-0.9-0.1c-0.3-0.1-0.6-0.3-0.7-0.6c-0.2-0.3-0.3-0.6-0.3-0.9 c0-0.4,0.2-0.8,0.5-1.1C511.6,110.3,512,110.1,512.4,110.1L512.4,110.1z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M516.8,113.5c0.5,0,1-0.2,1.4-0.4c0.4-0.3,0.8-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-1-0.7-1.3 c-0.4-0.4-0.8-0.6-1.3-0.7s-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.7,0.3,1.3,0.8,1.8 C515.5,113.3,516.2,113.5,516.8,113.5L516.8,113.5z M516.8,109.3c0.3,0,0.7,0.1,0.9,0.3c0.3,0.2,0.5,0.5,0.6,0.8s0.2,0.7,0.1,1 c-0.1,0.3-0.2,0.6-0.5,0.9c-0.2,0.2-0.5,0.4-0.9,0.5c-0.3,0.1-0.7,0-1-0.1s-0.6-0.3-0.8-0.6c-0.2-0.3-0.3-0.6-0.3-0.9 c0-0.4,0.2-0.9,0.5-1.2C516,109.4,516.4,109.3,516.8,109.3L516.8,109.3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M505.2,111l2.1,7.1c0,0,3.1-3.9,4-3.2s4.5,0,4.5,0l1.7,3.2h-1.7c0,0-2,21.1,0,22c2,0.9,1.7-3,1.7-3 s2.3,1.6,1.4,4.2c-0.9,2.6-6.5,4.7-8.6,0s-6-21.8-6-21.8L505.2,111z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M501,113.2c0-0.3,0.1-0.5,0.2-0.8s0.3-0.5,0.5-0.7s0.4-0.3,0.7-0.4c0.3-0.1,0.5-0.1,0.8-0.1 c0.2,0,0.4,0,0.5,0.1c0.3,1.1,0.6,2.3,0.9,3.4c-0.3,0.3-0.7,0.5-1.1,0.6s-0.8,0-1.2-0.1c-0.4-0.2-0.7-0.4-0.9-0.8 C501.1,114.1,501,113.7,501,113.2L501,113.2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M502.7,112.4c0.6,0.3,1.1,0.7,1.6,1.1c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.2,0,0.3c-0.1,0.2-0.4,0.3-0.6,0.2 c-0.5-0.4-1.1-0.7-1.6-1.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.2s0-0.1,0-0.2s0-0.1,0.1-0.2l0.1-0.1c0,0,0.1-0.1,0.2-0.1 S502.6,112.3,502.7,112.4C502.6,112.4,502.6,112.4,502.7,112.4L502.7,112.4z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M503.6,113.7l-0.3,0.6c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.2-0.1-0.2-0.3v-0.1 c0-0.1,0-0.2,0.1-0.2l0.3-0.6l0.1-0.1l0.1-0.1c0.1,0,0.2,0,0.3,0c0.1,0.1,0.2,0.2,0.2,0.3v0.1C503.6,113.5,503.6,113.6,503.6,113.7 L503.6,113.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000071535310810897357330000007149231751219217043_",
    x: 774,
    y: 0,
    width: 50,
    height: 130
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003809682887464911130000015177564234116670907_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071535310810897357330000007149231751219217043_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003809682887464911130000015177564234116670907_)"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M798,129.9c-0.1-0.6-8.4-63.7-10.4-79.8c-0.4-3.4-0.4-3.7-0.4-3.8l1-0.1c0,0.2,0.1,0.9,0.4,3.7 c2,16.1,10.3,79.2,10.4,79.8L798,129.9z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M808.8,129.9c-0.4-3.3-10.7-81.5-10.8-83.6l1-0.1c0.1,2.1,10.7,82.7,10.8,83.5L808.8,129.9z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M799.6,52h-10.8v0.9h10.8V52z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M800.1,58.6h-10.8v0.9h10.8V58.6z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M800.7,65.2h-10.8v0.9h10.8V65.2z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M801.5,71.8h-10.8v0.9h10.8V71.8z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M802.8,78.4H792v0.9h10.8V78.4z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M803.7,85h-10.8v1h10.8V85z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M804.2,91.6h-10.8v0.9h10.8V91.6z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M805,98.2h-10.8v0.9H805V98.2z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M806.1,104.8h-10.8v0.9h10.8V104.8z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M806.9,111.4h-10.8v0.9h10.8V111.4z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M807.8,118H797v0.9h10.8V118z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M808.6,124.6h-10.8v0.9h10.8V124.6z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M793,48.4h-3.5V130h3.5V48.4z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M805.8,33.5h-30.3v19h30.3V33.5z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M778.9,33.5h-3.4v19h3.4V33.5z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M786.6,33.5h-6.5v19h6.5V33.5z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M796.5,33.5h-8.8v19h8.8V33.5z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M802.5,33.5h-4.9v19h4.9V33.5z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M805.8,33.5h-2.2v19h2.2V33.5z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M807.5,31.7H774v3.6h33.5V31.7z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M780.1,32.1c0.9,0,1.7-0.8,1.6-1.7c0-0.9-0.8-1.6-1.7-1.6s-1.7,0.8-1.6,1.7 C778.4,31.4,779.2,32.2,780.1,32.1z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M787.2,15.9l7.3,0.3l3.2,1.9l4.8,10.3l-2.6,0.8l-12.7,2.4l-1.1-3.9L787.2,15.9z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M787,16.1L779.4,29l2.3,1l8-12.3L787,16.1z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M792.3,17.6c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4 C791.9,17.4,792.1,17.6,792.3,17.6z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M795.4,25.8c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4 C794.9,25.7,795.1,25.8,795.4,25.8z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M794.7,22.7c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4 C794.2,22.5,794.4,22.7,794.7,22.7z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M787.2,31.6l8.6-1.5v-3.2l4.1,2.4l1.4-0.4l-0.4,2.8L787.2,31.6L787.2,31.6z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M805.8,9.6c0-1-0.4-1.7-0.8-1.7c-0.5,0-0.9,0.8-0.9,1.7c0,1,0.4,1.7,0.8,1.7 C805.4,11.3,805.8,10.5,805.8,9.6z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M804.9,9.6V9.1V7.9l11.1,0v3.4l-11.1-0.1V9.6z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M813.9,9.6c0-1.9-0.6-3.4-1.4-3.5c-0.8,0-1.4,1.5-1.4,3.4s0.6,3.4,1.4,3.5C813.3,13.1,813.9,11.5,813.9,9.6 z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M812.5,9.6v-1V6.2h6v6.9h-6V9.6z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M818.4,6.8l0.1-2.2h3.5l-0.1,10.2h-3.5V6.8z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M820.5,9.7c0-2.8-0.9-5.1-2-5.1s-2.1,2.3-2.1,5.1s0.9,5.1,2,5.1C819.5,14.8,820.4,12.5,820.5,9.7z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M824,9.7c0-2.8-0.9-5.1-2-5.1s-2.1,2.3-2.1,5.1s0.9,5.1,2,5.1C823,14.8,824,12.5,824,9.7z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M823.5,9.7c0-2.2-0.7-3.9-1.6-3.9c-0.9,0-1.6,1.7-1.6,3.9s0.7,3.9,1.6,3.9S823.5,11.9,823.5,9.7z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M822.7,9.4c0.3,0,0.4-0.6,0.3-1.2c-0.1-0.6-0.4-1.1-0.7-1c-0.3,0-0.4,0.6-0.3,1.2 C822.2,8.9,822.5,9.4,822.7,9.4z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M812.6,8.4c0.4-0.2,0.8-0.3,1.2-0.5c-0.2-0.6-0.5-1-0.8-1c-0.5,0-0.9,0.7-1,1.7 C812.2,8.5,812.4,8.4,812.6,8.4z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M816,6.9h-3v1.3C814.1,7.8,815,7.3,816,6.9z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M812.3,13.6c0.9,0,1.7-0.8,1.6-1.7c0-0.9-0.8-1.6-1.7-1.6s-1.7,0.8-1.6,1.7 C810.6,12.9,811.4,13.6,812.3,13.6z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M795.2,7.1c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3S794.5,7.1,795.2,7.1z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M795,9.1c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C793.6,8.6,794.2,9.1,795,9.1z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M794.1,5c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C792.7,4.4,793.3,5,794.1,5z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M794.1,5c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C792.7,4.4,793.3,5,794.1,5z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M788.1,14c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C786.8,13.5,787.4,14,788.1,14z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M785.9,13c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C784.6,12.5,785.2,13,785.9,13z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M790,16.6l3.1,3.5l0.7-4.5l3.7-3.3l-4.6-10.8l-7.4,3.4L790,16.6z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M787,12.3c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C785.7,11.8,786.3,12.3,787,12.3z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M785.1,10.9c0.8,0,1.4-0.7,1.4-1.4c0-0.8-0.7-1.4-1.5-1.4s-1.4,0.7-1.4,1.4 C783.7,10.3,784.3,10.9,785.1,10.9z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M788,10.6c0.7,0,1.3-0.6,1.3-1.3S788.7,8,788,8s-1.3,0.6-1.3,1.3S787.3,10.6,788,10.6z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M786.1,10.1c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.4-1.3c-0.7,0-1.3,0.6-1.3,1.3 C784.8,9.6,785.4,10.1,786.1,10.1z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M784.6,8.4c0.8,0,1.4-0.7,1.4-1.4c0-0.8-0.7-1.4-1.5-1.4s-1.4,0.7-1.4,1.4C783.2,7.8,783.8,8.5,784.6,8.4z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M789.1,8.6c0.7,0,1.3-0.6,1.3-1.3S789.8,6,789.1,6s-1.3,0.6-1.3,1.3C787.8,8.1,788.4,8.6,789.1,8.6z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M787.7,8.5c1-0.3,1.5-1.2,1.2-2.1s-1.3-1.4-2.2-1.1c-1,0.3-1.5,1.2-1.2,2.1C785.7,8.3,786.7,8.8,787.7,8.5z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M785.6,6.6c0.8,0,1.4-0.7,1.4-1.4c0-0.8-0.7-1.4-1.5-1.4s-1.4,0.7-1.4,1.4C784.2,6,784.8,6.6,785.6,6.6z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M790.1,6.9c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.4-1.3c-0.7,0-1.3,0.6-1.3,1.3S789.3,6.9,790.1,6.9z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M788.2,6.4c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C786.9,5.9,787.5,6.4,788.2,6.4z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M787.2,4.9c0.8,0,1.4-0.7,1.4-1.4c0-0.8-0.7-1.4-1.5-1.4s-1.4,0.7-1.4,1.4C785.8,4.3,786.4,4.9,787.2,4.9z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M792,6.1c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.4-1.3c-0.7,0-1.3,0.6-1.3,1.3C790.7,5.5,791.3,6.1,792,6.1z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M790.4,5.9c1.1-0.3,1.8-1.5,1.5-2.5c-0.3-1.1-1.5-1.7-2.7-1.3c-1.1,0.3-1.8,1.5-1.5,2.5 C788.1,5.6,789.2,6.2,790.4,5.9z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M789,3.6c0.8,0,1.4-0.7,1.4-1.4c0-0.8-0.7-1.4-1.5-1.4s-1.4,0.7-1.4,1.4C787.5,3,788.2,3.6,789,3.6z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M793,4.3c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C791.6,3.8,792.2,4.3,793,4.3z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M791.1,3.9c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C789.7,3.3,790.3,3.9,791.1,3.9z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M790.9,2.8c0.8,0,1.4-0.7,1.4-1.4c0-0.8-0.7-1.4-1.5-1.4s-1.4,0.7-1.4,1.4C789.5,2.2,790.1,2.8,790.9,2.8z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M794.1,5c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C792.7,4.4,793.3,5,794.1,5z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M793.7,3.6c0.7,0,1.3-0.6,1.3-1.3S794.4,1,793.6,1c-0.7,0-1.3,0.6-1.3,1.3C792.4,3.1,793,3.6,793.7,3.6z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M792,3.3c0.8,0,1.4-0.7,1.4-1.4c0-0.8-0.7-1.4-1.5-1.4s-1.4,0.7-1.4,1.4C790.5,2.7,791.2,3.3,792,3.3z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M794.5,4.4c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C793.2,3.9,793.8,4.4,794.5,4.4z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M792.4,3c0.8,0,1.4-0.7,1.4-1.4c0-0.8-0.7-1.4-1.5-1.4s-1.4,0.7-1.4,1.4C790.9,2.4,791.6,3,792.4,3z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M795,5.5c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C793.7,5,794.3,5.6,795,5.5z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M793.5,10.3l1.4-0.3c0,0,0.2,1-0.5,1.2C793.7,11.3,793.5,10.3,793.5,10.3z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M794.5,7.6c0.2-0.3,0.2-0.6-0.1-0.9c-0.3-0.2-0.7-0.2-0.9,0.1c-0.2,0.3-0.2,0.6,0.1,0.9 C793.9,7.8,794.3,7.8,794.5,7.6z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M792.6,8.3c0.3-0.3,0.2-0.7-0.1-1c-0.3-0.2-0.7-0.2-1,0.1s-0.2,0.7,0.1,1C791.9,8.6,792.3,8.6,792.6,8.3z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M787.7,11.9c0.9,0,1.7-0.8,1.7-1.7s-0.8-1.6-1.7-1.6s-1.7,0.8-1.7,1.7C786,11.2,786.8,12,787.7,11.9z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M787,10.3c0.5,0.2,1,0.3,1.5,0.5c0.1,0,0.2,0,0.2,0c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2 c0-0.1-0.1-0.1-0.2-0.1c-0.5-0.2-1-0.3-1.5-0.5H787h-0.1c0,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0.1v0.1v0.1c0,0,0,0.1,0.1,0.1 C787,10.3,787,10.3,787,10.3L787,10.3z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M787.6,10.3l-0.1,0.6c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2,0s0.1,0,0.1-0.1V11l0.1-0.6 c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0C787.7,10.1,787.7,10.2,787.6,10.3 C787.6,10.2,787.6,10.3,787.6,10.3L787.6,10.3z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M803.9,22.2l-9.6-3.1l0.8-2.4l8,2.6l7.1-6.9l1.9,1.8L803.9,22.2z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidCultureResponsiveRight);
export default __webpack_public_path__ + "static/media/mid_culture_responsive-right.ce155660e5920510c45bca55b1b341ce.svg";
export { ForwardRef as ReactComponent };